












import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosCep extends Vue {
    get cep () {
        return this.$store.state.cotacao.cep;
    }

    set cep ( value ) {
        this.$store.commit("SET_CEP", value);
    }

    get errorCep () {
        return this.$store.state.errors.cep;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
